export const FIRST_TIME_CHECKLIST_DONE = [
  <>AWS CLI configured with credentials for both infra account (<code>322156488575</code>) and target account (<code>502309351201</code>)</>,
  <>CDK bootstrapped in target account: <code>cdk bootstrap aws://502309351201/us-east-1</code></>,
  <>Lambda layers deployed first (they are referenced by ARN from SSM by all other stacks)</>,
  <>Secrets created in Secrets Manager after first deploy: Paystack keys, MTN MoMo credentials, Twilio credentials, Google Maps API key</>,
  <>Cognito admin portal user created manually after admin stack deploys</>,
  <>Service areas configured in Settings → Service Areas before going live</>,
  <>Pricing config seeded: <code>npm run seed-pricing</code> from <code>libride_backend/</code></>,
];

export const FIRST_TIME_CHECKLIST_TODO: string[] = [];

export const DEPLOY_ORDER_COMMANDS = `# 1. Data layer (tables, queues, buckets, layers)
npx cdk deploy libride-dev-v2-data

# 2. Authentication (Cognito pools)
npx cdk deploy libride-dev-v2-authentication

# 3. Location service
npx cdk deploy libride-dev-v2-location

# 4. Error logging pipeline
npx cdk deploy libride-dev-v2-error-logging

# 5. Domain APIs (can deploy in parallel)
npx cdk deploy libride-dev-v2-ride libride-dev-v2-driver libride-dev-v2-rider libride-dev-v2-payment libride-dev-v2-kyc

# 6. Admin stack (depends on error-logging for S3 bucket)
npx cdk deploy libride-dev-v2-admin

# 7. Core API (depends on error-logging for Firehose stream name)
npx cdk deploy libride-dev-v2-core`;

export const TROUBLESHOOTING_DONE = [
  <><strong>Riders not receiving ride updates</strong> — Check <code>onRiderUpdates</code> subscription is connected (look for WebSocket errors in Error Logs). Verify Rider API AppSync endpoint in Core API config table.</>,
  <><strong>Driver location not updating on rider map</strong> — Check <code>DRIVER_LOCATION_UPDATE</code> events in Error Logs. Verify driver has location permission granted and is on an active trip status.</>,
  <><strong>Ride matching queue backing up</strong> — Check System Status → Queue Health. If <code>rideMatchingDLQ</code> has messages, inspect them in SQS console for the failure reason.</>,
  <><strong>Cashout not processing</strong> — Check <code>cashoutProcessingDLQ</code> depth in System Status. Verify MTN MoMo / Orange Money credentials in Secrets Manager are current.</>,
  <><strong>Driver KYC documents not loading</strong> — Pre-signed S3 URLs expire after 15 minutes. Refresh the Driver Approval page to generate new URLs.</>,
];

export const TROUBLESHOOTING_TODO: string[] = [];

export const REQUIRED_SECRETS = [
  { name: 'libride-{env}-v2-data/paystack-credentials', what: 'Paystack secret_key, public_key, webhook_secret', where: 'Paystack Dashboard → Settings → API Keys & Webhooks (Test or Live mode)' },
  { name: 'libride-{env}-v2-data/twilio-secret',         what: 'Twilio Account SID + Auth Token',          where: 'Twilio Console → Account Info' },
  { name: 'libride-{env}-v2-data/mtn-momo-collection',   what: 'MTN MoMo Collection API credentials',      where: 'MTN MoMo Developer Portal' },
  { name: 'libride-{env}-v2-data/mtn-momo-disbursement', what: 'MTN MoMo Disbursement API credentials',    where: 'MTN MoMo Developer Portal' },
  { name: 'libride-{env}-v2-ride/google-maps-api-key',   what: 'Google Maps Routes API key',               where: 'Google Cloud Console → APIs & Services' },
];
